<div class="funz-admin-participant-stats" *ngIf="participantsStatsAvailable" >
  <span class="tickets-used">
    {{ adminParticipantsStats?.ticketsUsed }}
  </span>
  <span class="max-people">
    {{ adminParticipantsStats?.maxPeople }}
  </span>
</div>
